import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductModalProductDetailsSupplierFragmentDoc } from './ProductModalProductDetailsSupplier.generated'
import { ProductModalProductPreviewSupplierFragmentDoc } from './ProductModalProductPreviewSupplier.generated'
import * as Types from './purchasePlus_graphql'

export const ProductModalSupplierFragmentDoc = gql`
  fragment ProductModalSupplier on Supplier {
    id
    ...ProductModalProductPreviewSupplier
    ...ProductModalProductDetailsSupplier
    supplierRelationship {
      id
      preferredSupplier
    }
  }
  ${ProductModalProductPreviewSupplierFragmentDoc}
  ${ProductModalProductDetailsSupplierFragmentDoc}
` as unknown as DocumentNode<Types.ProductModalSupplierFragment, unknown>
